import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f11f728"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No users found", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "table table-hover"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { width: "30%" }, "Username"),
  /*#__PURE__*/_createElementVNode("th", { width: "10%" }, "Office"),
  /*#__PURE__*/_createElementVNode("th", { width: "30%" }, "Customer Name"),
  /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Confirmation Status"),
  /*#__PURE__*/_createElementVNode("th", { width: "10%" }, "Status")
], -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-enabled chip" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }),
  /*#__PURE__*/_createTextVNode(" Enabled ")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-disabled chip" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus-circle" }),
  /*#__PURE__*/_createTextVNode(" Disabled ")
], -1))
const _hoisted_13 = [
  _hoisted_12
]

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { Office, CognitoUser } from '@/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserList',
  setup(__props) {

const store = useStore();
const router = useRouter();

// Accessing getters using the Composition API
const hasBlockingRequests = computed((): boolean => store.getters['app/hasBlockingRequests']);
const getOffices = computed((): Office[] => store.getters['offices/getOffices']);
const users = computed((): CognitoUser[] => store.getters['sysadmin/list']);

const edit = (user: any) => { // Replace 'any' with 'CognitoUser' if the type is imported
  router.push({
    name: "usermanagement",
    params: { sub: user.findAttributeValue("sub") },
  });
};

const findUserACTOffice = (user: any): string | undefined => { // Replace 'any' with 'CognitoUser' if the type is imported
  let office = getOffices.value.find(
    (office) => office.id === user.findAttributeValue("custom:office_id")
  );
  return office ? office.name : undefined;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!users.value.length && !hasBlockingRequests.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: user.Username,
                onClick: ($event: any) => (edit(user))
              }, [
                _createElementVNode("td", null, _toDisplayString(user.Username), 1),
                _createElementVNode("td", null, _toDisplayString(findUserACTOffice(user)), 1),
                _createElementVNode("td", null, _toDisplayString(user.findAttributeValue("custom:company_name")), 1),
                _createElementVNode("td", null, _toDisplayString(user.UserStatus), 1),
                (user.Enabled)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_8, _hoisted_10))
                  : (_openBlock(), _createElementBlock("td", _hoisted_11, _hoisted_13))
              ], 8, _hoisted_7))
            }), 128))
          ])
        ]))
  ]))
}
}

})